import axios from '../../axios'

// 新增省份批次信息
export const addProvinceBatch = (data) => {
    return axios({
        url: '/api/data/wish/batch',
        method: 'POST',
        data
    })
}

// 修改省份批次信息
export const editProvinceBatch = (data) => {
    return axios({
        url: '/api/data/wish/batch',
        method: 'PUT',
        data
    })
}

// 删除省份批次信息
export const deleteProvinceBatch = (data) => {
    return axios({
        url: '/api/data/wish/batch',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索省份批次信息列表
export const getProvinceBatchList = (data) => {
    return axios({
        url: '/api/data/wish/batch',
        method: 'GET',
        data
    })
}

// 获取省份批次详情
export const getProvinceBatchInfo = (data) => {
    return axios({
        url: '/api/data/wish/batch/info',
        method: 'GET',
        data
    })
}

// 导入省份批次
export const importProvinceBatch = (data) => {
    return axios({
        url: '/api/data/wish/batch/import',
        method: 'POST',
        data
    })
}

// 导出省份批次
export const exportProvinceBatch = (data) => {
    return axios({
        url: '/api/data/wish/batch/export',
        method: 'POST',
        data
    })
}

// 批量更新省份批次
export const updateProvinceBatch = (data) => {
    return axios({
        url: '/api/data/wish/batch/batch/update',
        method: 'POST',
        data
    })
}

// 批量删除省份批次
export const queryDelProvinceBatch = (data) => {
    return axios({
        url: '/api/data/wish/batch/batch/delete',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/provinceBatch.js